import { render, staticRenderFns } from "./ZubeWrapper.vue?vue&type=template&id=7129c1c1&scoped=true&"
import script from "./ZubeWrapper.vue?vue&type=script&lang=js&"
export * from "./ZubeWrapper.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7129c1c1",
  null
  
)

export default component.exports